module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapterNumber",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTOCAnchor-13"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf2#_idTOCAnchor-12"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf3#_idTOCAnchor-11"
    }
  }, [_vm._v("1. "), _c('br'), _vm._v("The importance of the"), _c('br'), _vm._v("psychological side of golf.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf4#_idTOCAnchor-10"
    }
  }, [_vm._v("2. "), _c('br'), _vm._v("How fifty top pros rank the"), _c('br'), _vm._v("six major psychological factors.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf5#_idTOCAnchor-9"
    }
  }, [_vm._v("3. "), _c('br'), _vm._v("How to improve your game"), _c('br'), _vm._v("through gaining new confidence.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf6#_idTOCAnchor-8"
    }
  }, [_vm._v("4. "), _c('br'), _vm._v("How the pros rank the"), _c('br'), _vm._v("eight major golfing skills.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf7#x.17576"
    }
  }, [_vm._v("5. "), _c('br'), _vm._v("Attributes and abilities the pros"), _c('br'), _vm._v("would like most to possess.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf8#_idTOCAnchor-7"
    }
  }, [_vm._v("6. "), _c('br'), _vm._v("What the pros feel"), _c('br'), _vm._v("are their strengths.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf9#_idTOCAnchor-6"
    }
  }, [_vm._v("7. "), _c('br'), _vm._v("What the pros feel"), _c('br'), _vm._v("we their weaknesses.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf10#_idTOCAnchor-5"
    }
  }, [_vm._v("8. "), _c('br'), _vm._v("What the pros think"), _c('br'), _vm._v("about practice and layoffs.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf11#_idTOCAnchor-4"
    }
  }, [_vm._v("9. "), _c('br'), _vm._v("Analysis of the “blank mind” theory."), _c('br'), _vm._v("Mental tricks to help your driving and putting.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf12#_idTOCAnchor-3"
    }
  }, [_vm._v("10. "), _c('br'), _vm._v("Caddies and conversation.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf13#_idTOCAnchor-2"
    }
  }, [_vm._v("11. "), _c('br'), _vm._v("Dreams, superstition, and luck.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf14#x.17599"
    }
  }, [_vm._v("12. "), _c('br'), _vm._v("When franquilizers and self-hypnosis fail, try prayer.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf15#x.17602"
    }
  }, [_vm._v("13"), _c('br'), _vm._v("“Gamesmanship” among the touring pros. Real or imagined? Intentional or unintentional?")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf16#x.17605"
    }
  }, [_vm._v("14. "), _c('br'), _vm._v("A positive attitude; foundation for all other psychological strengths.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf17#x.17608"
    }
  }, [_vm._v("Appendix"), _c('br'), _vm._v("Professional Golfers’ Questionnaire")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "#/MindOverGolf18"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83a2fe04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MindOverGolf-1.vue
// module id = 66
// module chunks = 0